import axios from 'axios';
import store from '../../store';

const model = () => {
	return {
		sku:	'',
		type: 	null,
		cover: 	null,
		qty:	'',
		amount:	''
	};
};

const types = () => {
	return [
		{
			label:	'Pris',
			value:	'price'
		},
		{
			label:	'Rabat',
			value:	'discount'
		},
		{
			label:	'Procent',
			value:	'percent'
		}
	];
};

const covers = () => {
	return [
		{
			label:	'Alle',
			value:	'all'
		},
		{
			label:	'Efterfølgende',
			value:	'following'
		}
	];
};

export default {
	model,
	types,
	covers
};